import { memo } from "react";
import type { IconProps } from "./types";

const Icon: React.FC<IconProps> = ({ className, id, ref, ...rest }) => {
  return (
    <svg className={className} ref={ref} {...rest}>
      <use href={`/sprite.svg#${id}`} />
    </svg>
  );
};

export default memo(Icon);
